import React from 'react';

import classes from './BuildControls.module.css';
import BuildControl from './BuildControl/BuildControl';

const controls = [
    { label: 'Salad', type: 'salad' },
    { label: 'Bacon', type: 'bacon' },
    { label: 'Cheese', type: 'cheese' },
    { label: 'Meat', type: 'meat' },
];

const buildControls = (props) => {
        return  <div className={classes.BuildControls}>
                    
                    <p>Current Price: <strong>{props.price.toFixed(2)} $</strong></p>
                    {controls.map( ctrl => {
                        return <BuildControl 
                                    key={ctrl.label} 
                                    ingredientLabel={ctrl.label}
                                    added={props.ingredientsAdded.bind(this,ctrl.type)}
                                    // added={() => props.ingredientsAdded(ctrl.type)} 
                                    remove={() => props.ingredientsRemoved(ctrl.type)}
                                    disable={props.disabled[ctrl.type]} />
                    })}
                    
                    <button 
                        className={classes.OrderNow}
                        disabled={!props.purchasable}
                        onClick={props.ordered} >
                            {props.isAuthenticated ? 'ORDER NOW' : 'SIGN IN TO ORDER'} 
                        </button>
                </div>
}

export default buildControls;